import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LabelsModule } from '../labels/labels.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { HelperThreeDotsMenuModule } from '../helpers/navigation/three-dots-menu/three-dots-menu.module';
import { LayoutTitlesModule } from '../layout/titles/titles.module';

import { ProjectsNextStagesMenuComponent } from './next-stages-menu/next-stages-menu.component';
import { ProjectDetailsBreadcrumbHeaderComponent } from './breadcrumb-header/breadcrumb-header.component';

@NgModule({
    imports: [
        CommonModule,
        LabelsModule,
        HelperThreeDotsMenuModule,
        LayoutTitlesModule,
        HelperBoxModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProjectsNextStagesMenuComponent,
        ProjectDetailsBreadcrumbHeaderComponent
    ],
    exports: [
        ProjectsNextStagesMenuComponent,
        ProjectDetailsBreadcrumbHeaderComponent
    ],

})
export class CoreProjectsModule { }
